import React, {useEffect, useState} from "react";
import HeaderComponent from "../../components/HeaderComponent";
import "./../../utils/Style/pages/Exchange.scss";
import {useExchangeApi} from "../../api/ExchangeAPI";
import ExchangeHistory from "../../components/Exchange/ExchangeHistory";
import useCommonAPI from "../../api/CommonAPI";
import {useDispatch, useSelector} from "react-redux";
import {setActionPayload, setActionType} from "../../features/authorizationSlice";
import {ACTION_TYPES} from "../../app/actionTypes";
import {useOutletContext} from "react-router-dom";
import BlurLoading from "../../components/BlurLoading";
import {formatLBP, formatNum, formatUSD, parseFormattedNumber} from "../../features/ValueFormater";
import {faArrowDown, faCaretDown} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

function Exchange() {
    const {getExchangeRate, exchangeRate} = useExchangeApi();
    const dispatch = useDispatch();
    const [onOpenQrAfterGenerate] = useOutletContext();

    const [buyRate, setBuyRate] = useState(0);
    const [buyValue, setBuyValue] = useState(0);
    const [buyString, setBuyString] = useState("");
    const [sellRate, setSellRate] = useState(0);
    const [sellValue, setSellValue] = useState(1);
    const [selectedAccount, setSelectedAccount] = useState('LBP');
    const [payload ,setPayload] = useState({
        ExchangeFromAmount: 0,
        ExchangeFromCurrencyID: 0,
        ExchangeToCurrencyID: 0,
        ExchangeBuy: 0,
        ExchangeSell: 0
    });

    const {flag} = useSelector((state)=>state.transferResponse);

    useEffect(() => {
        getExchangeRate();
    }, [flag]);


    useEffect(() => {
        if (exchangeRate !== null) {
            setBuyRate(exchangeRate.Buy);
            setSellRate(exchangeRate.Sell);
        }
    }, [exchangeRate]);


    useEffect(()=>{
        setPayload({
            ExchangeFromAmount: buyValue,
            ExchangeFromCurrencyID: selectedAccount === 'USD'? 1 : 2,
            ExchangeToCurrencyID: selectedAccount === 'USD'? 2 : 1,
            ExchangeBuy: buyRate,
            ExchangeSell: sellRate
        })
    }, [buyValue, selectedAccount]);

    const handleChange = (e) => {
        const rawValue = e.target.value;
        if (!rawValue) {
            setBuyValue(0)
            return;
        }

        const numericValue = rawValue.replace(/[^\d.]/g, '');
        const limitedValue = (numericValue !== "" && numericValue!=="0")
            ? numericValue.match(/^[0]*(\d+(?:\.{0}\d{0})?)/)[1]
            : "";
        setBuyValue(limitedValue !== ""? Number(limitedValue): "");
        setSellValue((limitedValue !== ""?Number(limitedValue): 0) / buyRate);
    }

    const handleChange2 = (e) => {
        const rawValue = e.target.value;
        if (!rawValue) {
            setBuyValue(0)
            return;
        }

        // const numericValue = rawValue.replace(/[^\d]/g, '');
        const numericValue = rawValue.replace(/[^\d.]/g, '');

        const limitedValue = (numericValue !== "" && numericValue!=="0")
            ? numericValue.match(/^[0]*(\d+(?:\.\d{0,2})?)/)[0]
            : "";
        setBuyValue(limitedValue !== ""? Number(limitedValue): "");
        setSellValue((limitedValue !== ""?Number(limitedValue): 0) * sellRate);

        const parts = limitedValue.split('.');
        const formattedInteger = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
        const formattedValue = parts.length === 2 ? `${formattedInteger}.${parts[1]}` : formattedInteger;

        setBuyString(formattedValue);
    }

    const handleSwap = (curr) => {
        setSelectedAccount(curr);
        setBuyValue(0);
        if(curr==="USD") setSellValue(sellRate)
        if(curr==="LBP") setSellValue(1)
    }


    function InitiateExchange() {
        if(payload.ExchangeFromAmount !== 0 && payload.ExchangeFromAmount !== "" && sessionStorage.getItem("EntityRole") !== "VIEWER") {
            dispatch(setActionType(ACTION_TYPES.INITIATE_EXCHANGE));
            dispatch(setActionPayload(payload));

            onOpenQrAfterGenerate();
        }
    }

    return (
        <>
            <HeaderComponent title="Exchange"/>
            <div className="ExchangePage">
                {<BlurLoading/>}
                <div className="container-fluid ExchangePagecontainer">
                    <div className="row CurrencyExchange">
                        <div className="title">Currency Exchange</div>
                        <div className="subtitle">Buy & Sell Instantly at black market rate</div>

                        {selectedAccount === "LBP" && (
                            <>
                                <div className="update">
                                    <div className="search-box">
                                        <input type="text"
                                               id="number-input"
                                               className="search-input"
                                               placeholder={formatLBP(buyRate)}
                                               onChange={(e) => handleChange(e)}
                                               disabled={sessionStorage.getItem("EntityRole") === "VIEWER"}
                                               value={buyValue !== 0 ? formatLBP(buyValue): null}
                                        />
                                        <button className="search-button">
                                            LBP <FontAwesomeIcon icon={faCaretDown}/>
                                        </button>
                                    </div>
                                </div>
                                <button onClick={()=>handleSwap("USD")}><img src="/Images/exchange.png" alt="Logo"/></button>
                                <div className="update">
                                    <div className="search-box">
                                        <input type="text"
                                               className="search-input"
                                               placeholder={formatUSD(sellValue)}
                                               disabled={true}
                                        />
                                        <button className="search-button">
                                            USD <FontAwesomeIcon icon={faCaretDown}/>
                                        </button>
                                    </div>
                                </div>
                            </>
                        )
                        }
                        {selectedAccount === "USD" && (
                            <>
                                <div className="update">
                                    <div className="search-box">
                                        <input type="text"
                                               id="number-input"
                                               className="search-input"
                                               onChange={(e) => handleChange2(e)}
                                               placeholder="1"
                                               value={buyValue !== 0 ? buyString: null}
                                               // value={buyValue !== 0 ? formatNum(buyValue): null}
                                               disabled={sessionStorage.getItem("EntityRole") === "VIEWER"}
                                        />
                                        <button className="search-button">
                                            USD <FontAwesomeIcon icon={faCaretDown}/>
                                        </button>
                                    </div>
                                </div>
                                <button onClick={()=>handleSwap("LBP")}><img src="/Images/exchange.png" alt="Logo"/></button>

                                <div className="update">
                                    <div className="search-box">
                                        <input type="text"
                                               className="search-input"
                                               disabled={true}
                                               placeholder={formatLBP(sellValue)}
                                        />
                                        <button className="search-button">
                                            LBP <FontAwesomeIcon icon={faCaretDown}/>
                                        </button>
                                    </div>
                                </div>
                            </>
                        )
                        }

                        <button
                            className={ (buyValue==="" || buyValue === 0) ? "Exchangebtn disabled" : "Exchangebtn"}
                            onClick={()=>InitiateExchange()}
                        >
                            Exchange
                        </button>
                    </div>

                    <ExchangeHistory/>

                </div>
            </div>
        </>
    );
}

export default Exchange;